// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmDropdown = function(options) {

		const $context = $(this);

		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			toggle: '.dropdown__toggle',
			menu: '.dropdown__menu',
			className: 'dropdown--open'
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$toggle = $context.find(settings.toggle);
			settings.$menu = $context.find(settings.menu);
		}

		// On load function.
		methods.initContext = function () {
			methods.setCurrentSettings();
		}

		// Bind events
		methods.events = function() {
			// Location button for geolocation
			settings.$toggle.on('click.lmDropdown', function(event) {
				event.preventDefault();
				
				let $this = $(this),
					$parent = $this.parent();

				if ($parent.hasClass(settings.className)) {
					$parent.removeClass(settings.className)
				} else {
					$parent.addClass(settings.className)
				}
				
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}		

		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.events(this);
	};

	if($('.dropdown').length) {
		$('.dropdown').lmDropdown();
	}

}(jQuery));